import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { immunizationQKeys } from "@hooks/queries/immunization/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useCreateImmunization = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (immunization: FormData) => {
      return api.post("preventative/", immunization, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: (res: any) => {
      // console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-immunization-success",
      });
      queryClient.invalidateQueries({
        queryKey: immunizationQKeys.patient(res.data.patient_id),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(res.data.patient_id),
      });
    },

    onError: (res: any) => {
      console.error("[From Create Immunization]", res);
      handleErrors(res, "mutation");
    },
  });
};
